import { useContext } from 'react';
import { MobXProviderContext } from 'mobx-react';
var useSidebarStore = function () { return useContext(MobXProviderContext).sidebarStore; };
export default useSidebarStore;
//# sourceMappingURL=UseSidebarStore.js.map